// LocMap.js

import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import leaflet from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { useAuth } from '../contexts/CommonCtx';
import { getPosition } from '../contexts/CommonFunc';
//import axios from 'axios';
//import moment from 'moment';
//import { ToastContainer, toast } from 'react-toastify';
//import 'react-toastify/dist/ReactToastify.min.css';
//import FixedHeader from './FixedHeader';
//import FixedBottom from './FixedBottom';
//import { useTheme } from "@emotion/react";
import { styled } from '@mui/material/styles';
import Container from '@mui/material/Container';
//import Card from '@mui/material/Card';
//import Box from '@mui/material/Box';
//import Grid from '@mui/material/Grid';
import Toolbar from '@mui/material/Toolbar';
//import AppBar from '@mui/material/AppBar';
//import Paper from '@mui/material/Paper';
//import Avatar from '@mui/material/Avatar';
//import IconButton from '@mui/material/IconButton';
//import Button from '@mui/material/Button';
//import TextField from '@mui/material/TextField';
//import FormControlLabel from '@mui/material/FormControlLabel';
//import InputLabel from '@mui/material/InputLabel';
//import Checkbox from '@mui/material/Checkbox';
//import Link from '@mui/material/Link';
//import Typography from '@mui/material/Typography';
//import FormControl from '@mui/material/FormControl';
//import Select from '@mui/material/Select';
//import NativeSelect from '@mui/material/NativeSelect';
//import MenuList from '@mui/material/MenuList';
//import MenuItem from '@mui/material/MenuItem';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import BottomNavigation from '@mui/material/BottomNavigation';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
//import markerRetina from 'leaflet/dist/images/marker-icon-2x.png';

let DefaultIcon = leaflet.icon({
    //iconRetinaUrl: markerRetina,
    iconUrl: markerIcon,
    shadowUrl: markerShadow
});
leaflet.Marker.prototype.options.icon = DefaultIcon;

//delete leaflet.Icon.Default.prototype._getIconUrl;
//leaflet.Icon.Default.mergeOptions({
//    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
//    iconUrl: require('leaflet/dist/images/marker-icon.png'),
//    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
//});

const LocMap = (props) => {
    //console.log('pics_props', props);

    //const theme = useTheme();

    const [success, setSuccess] = useState(false);
    const [failed, setFailed] = useState(false);
    
    //const ref = useRef(null);

    //const { user, ml, mode, camera, ppms, port } = useAuth();
    const { user } = useAuth();
    //console.log('pics_user', user);
    
    //const [ projs, setProjs ] = useState([]);
    //const [ proj, setProj ] = useState('');

    const [ coords, setCoords ] = useState({ latitude: 0, longitude: 0 });

    //const getProjects = async() => {
    //    try {
    //        const res = await axios.get(`${ppms}:${port}/appms/projs`, { withCredentials: true });
    //        //console.log('projs_res', res);
    //        setProjs(res.data);
    //        if (res.data.length > 0) {
    //            //setProj(res.data[0].proj_cd);
    //            setProj(res.data[0].proj_id);
    //            return res.data[0].proj_id;
    //        } else {
    //            return null;
    //        }
    //    } catch (err) {
    //        console.log(err);
    //    }
    //};

    //const handleProjs = (e) => {
    //    //console.log('handle', e);
    //    setProj(e.target.value);
    //};

    const getLocation = async() => {
        try {
            let pos = await getPosition();
            setCoords(pos.coords);
        } catch (error) {
            console.error(error);

            if (0) {
            switch(error.code) {
                case error.PERMISSION_DENIED: // 사용자가 Geolocation API 사용 요청을 거부
                break;

                case error.POSITION_UNAVAILABLE: // 가져온 위치 정보를 사용할 수 없을 때
                break;

                case error.TIMEOUT: // 위치 정보를 가져오기 위한 요청이 허용 시간을 초과
                break;

                case error.UNKNOWN_ERROR: // 알 수 없는 오류가 발생
                break;

                default:
                break;
            } // switch
            } // if 
        }
    };

    useEffect(() => {
        (async() => {
            //let pid = await getProjects();
            //await getProjects();
            getLocation();
        })();
    }, []);

    //useEffect(() => {
    //    //console.log('mode', mode, camera);
    //    if (mode === 'SitePics' && camera && camera.includes('action')) {
    //    };
    //}, [ mode, camera ]);

    if (!user.lang){
        return <Navigate replace to='/signin' />; 
    }

    const handleCloseSuccess = (event, reason) => {
        if (reason === 'clickaway') return;
        setSuccess(false);
    };
    const handleCloseFailed = (event, reason) => {
        if (reason === 'clickaway') return;
        setFailed(false);
    };

    const ContainerMaps = styled(Container)(({theme}) => ({
        display: 'block',
        //direction: 'column',
        //flexGrow: 1,
        width: '100%',
        height: '100%',
        overflow: 'auto',
        //alignItems: 'center',
        //justifyContent: 'center',
        background: '#f0f8ff',
        //background: theme.palette.grey[50],
    }));
    //const BoxProj = styled(Box)(({theme}) => ({
    //    display: 'flex',
    //    //flexDirection: 'column',
    //    //flexGrow: 1,
    //    //flexDirection: {
    //    //    xs: 'column', // mobile
    //    //    sm: 'row', // tablet and up
    //    //},
    //    width: '100%',
    //    height: '100%',
    //    alignItems: 'center',
    //    justifyContent: 'center',
    //    //borderRadius: 10,
    //    //background: theme.palette.white,
    //    //boxShadow: '0 1px 3px rgba(0, 127, 255, 0.1)',
    //}));
    //const ButtonMenu = styled(Button)(({theme}) => ({
    //    width: '100%',
    //    height: '10vh',
    //    borderRadius: 10,
    //    //color: theme.palette.primary.main,
    //    //background: theme.palette.success.light,
    //    background: '#48d1cc', //'#6495ed',
    //    //boxShadow: '0 1px 3px rgba(0, 127, 255, 0.1)',
    //}));
    //const CardMenu = styled(Card)(({theme}) => ({
    //    display: 'flex',
    //    flexDirection: 'column',
    //    flexGrow: 1,
    //    //flexDirection: {
    //    //    xs: 'column', // mobile
    //    //    sm: 'row', // tablet and up
    //    //},
    //    minWidth: '80%',
    //    width: '80%',
    //    height: '10vh',
    //    alignItems: 'center',
    //    justifyContent: 'center',
    //    borderRadius: 10,
    //    background: theme.palette.white,
    //    boxShadow: '0 1px 3px rgba(0, 127, 255, 0.1)',
    //}));
    //const BoxImg = styled(Box)(({theme}) => ({
    //    //display: 'none',
    //    display: 'flex',
    //    width: '100%',
    //    height: '40vh',
    //    //backgroundImage: 'url(https://source.unsplash.com/random?wallpapers)',
    //    //backgroundImage: `url(${logo})`,
    //    backgroundRepeat: 'no-repeat',
    //    //backgroundColor: '#ffffff', //(t) => t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
    //    backgroundSize: 'contain',
    //    backgroundPosition: 'center',
    //    borderRadius: 5,
    //    borderColor : '#e0e0e0',
    //    borderWidth: '1px',
    //    borderStyle: 'solid',
    //}));

    return (
        <ContainerMaps maxWidth={false} disableGutters sx={{ m:0, p:0, width: '100%', flexGrow: 1 }}>
            <Toolbar sx={{ display: 'block', minHeight: '56px' }} />
            {/*
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Box sx={{ p: 2 }}>
                    <BoxProj sx={{ m: 0 }}>
                        <FormControl variant="outlined" sx={{ mx: 0, my: 1, width: '100%' }} size="small" fullWidth>
                            <Select id="sel-projs" value={proj} onChange={handleProjs} displayEmpty>
                                { projs.map((p, idx) => (
                                    <MenuItem key={p.proj_id} value={p.proj_id} dense>
                                        <Typography textAlign="center" variant="subtitle2">{p.proj_nm}</Typography>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </BoxProj>
                </Box>
            </Box>
            */}
            <MapContainer style={{ width: '100%', height: 'calc(100% - 112px)', zIndex: 1 }} center={[coords.latitude, coords.longitude]} zoom={13}
                whenCreated={map => setInterval(() => { map.invalidateSize()}, 100)}
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker position={[coords.latitude, coords.longitude]}>
                    <Popup>
                        { coords.latitude + ',' + coords.longitude }
                    </Popup>
                </Marker>
            </MapContainer>
            <Snackbar open={success} autoHideDuration={3000} onClose={handleCloseSuccess} sx={{ opacity: 0.85 }}>
                <Alert onClose={handleCloseSuccess} severity="success" sx={{ width: '100%', backgroundColor: 'rgba(40, 40, 40, 0.85)' }} elevation={6} variant="filled">
                    Successfully completed!
                </Alert>
            </Snackbar>
            <Snackbar open={failed} autoHideDuration={3000} onClose={handleCloseFailed} sx={{ opacity: 0.85 }}>
                <Alert onClose={handleCloseFailed} severity="error" sx={{ width: '100%', backgroundColor: 'rgba(40, 40, 40, 0.85)' }} elevation={6} variant="filled">
                    Failed!
                </Alert>
            </Snackbar>
            <BottomNavigation value="" sx={{ display: 'block', minHeight: '56px', background: 'none' }} />
        </ContainerMaps>
    );
};

export default LocMap;



